import { UPDATE_REPORT_PITCH_API } from 'constants/AppConstants';
import { constructUrlWithUserDetails } from 'utils/app.utils';

// #genai Name the default export without changing its signature or callers.
export default async function updateReportPitch(reportId, requestBody, signature) {
  try {
    const baseUrl = UPDATE_REPORT_PITCH_API.replace(':reportId', reportId);
    let URL = constructUrlWithUserDetails(baseUrl);
    if (signature) {
      URL += `${URL.includes('?') ? '&' : '?'}signature=${encodeURIComponent(signature)}`;
    }

    const response = await fetch(URL, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
      skipAuthHeader: true,
    });

    if (response.status !== 200) return { ok: false, status: response.status };
    const json = await response.json();
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
}
